import CardActions from '@material-ui/core/CardActions';
import React from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  Filter,
  List,
  ListButton,
  LongTextInput,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Responsive,
  SaveButton,
  SelectInput,
  SimpleForm,
  SimpleList,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';

export const GeofenceFilter = props => (
  <Filter {...props}>
    <ReferenceInput label="Market" source="market_id" reference="markets">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Airport" source="airport_id" reference="airports">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <TextInput label="Name" source="display_name" />
    <BooleanInput label="Active" source="active" />
    <NumberInput label="Min Radius" source="radius" />
  </Filter>
);

export const GeofenceList = props => (
  <List {...props} bulkActionButtons={false} filters={<GeofenceFilter />}>
    <Responsive
      small={<SimpleList primaryText={record => `${record.display_name}`} />}
      medium={
        <Datagrid>
          <EditButton />
          <TextField source="id" />
          <TextField label="Name" source="display_name" />
          <NumberField source="radius" />
          <NumberField source="extended_radius" />
          <ReferenceField label="Market" source="market_id" reference="markets">
            <TextField source="short_name" />
          </ReferenceField>
          <ReferenceField
            label="Airport"
            source="airport_id"
            reference="airports"
          >
            <TextField source="code" />
          </ReferenceField>
          <ReferenceField label="Event" source="event_id" reference="events">
            <TextField source="name" />
          </ReferenceField>
          <BooleanField source="active" />
        </Datagrid>
      }
    />
  </List>
);

export const GeofenceCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Airport"
        source="airport_id"
        reference="airports"
        allowEmpty
      >
        <SelectInput optionText="code" />
      </ReferenceInput>
      <NumberInput label="Event ID" source="event_id" />
      <LongTextInput source="name" />
      <LongTextInput source="display_name" />
      <BooleanInput source="active" />
      <NumberInput source="lat" />
      <NumberInput source="lon" />
      <NumberInput source="radius" />
      <NumberInput source="extended_radius" />
      <BooleanInput source="notify_on_entry" />
      <BooleanInput source="notify_on_exit" />
    </SimpleForm>
  </Create>
);

const PostEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const GeofenceEdit = props => (
  <Edit title={<GeofenceTitle />} actions={<GeofenceActions />} {...props}>
    <SimpleForm toolbar={<PostEditToolbar />}>
      <DisabledInput source="id" />
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Airport"
        source="airport_id"
        reference="airports"
        allowEmpty
      >
        <SelectInput optionText="code" />
      </ReferenceInput>
      <NumberInput label="Event ID" source="event_id" />
      <LongTextInput source="name" />
      <LongTextInput source="display_name" />
      <BooleanInput source="active" />
      <NumberInput source="lat" />
      <NumberInput source="lon" />
      <NumberInput source="radius" />
      <NumberInput source="extended_radius" />
      <BooleanInput source="notify_on_entry" />
      <BooleanInput source="notify_on_exit" />
    </SimpleForm>
  </Edit>
);

const GeofenceTitle = ({ record }) => {
  return <span>{record ? `"${record.display_name}"` : ''}</span>;
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const GeofenceActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/geofences.js